import React, { useState } from "react";
import "./TrackJob.css";
import { Paper, TextField, Button, CircularProgress } from "@mui/material";
import LabRequestProgress from "../progress/LabRequestProgress";
import axios from "axios";
import { Typography, InputAdornment, Box } from "@mui/material";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";

import SearchIcon from "@mui/icons-material/Search";
import ScienceIcon from "@mui/icons-material/Science";
import { DATA_SAVE_URL } from "../utils/UrlHandle";
import LoadingBackDrop from "../global/LoadingBackDrop";

function TrackJob() {
  const [jobNo, setJobNo] = useState("");
  const [loading, setLoading] = useState(false);
  const [labRequestData, setLabRequestData] = useState(null);
  const [year, setYear] = useState("2026");

  const searchJob = async () => {
    if (!jobNo.trim()) {
      alert("Please enter a job number");
      return;
    }
    setLoading(true);
    try {
      const response = await axios.get(
        DATA_SAVE_URL + "/api/v1/reports/progress/" + 1,
        {
          responseType: "json",
          params: {
            year: year,
            autoIdByYear: jobNo,
          },
        },
      );

      setLabRequestData(response.data);
    } catch (error) {
      console.error("Error fetching PDF:", error);
      // setError("Failed to load PDF. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      searchJob();
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: "#f5f7fb",
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        pt: 8,
        px: 2,
      }}
    >
      {loading ? <LoadingBackDrop openBackDrop={loading} /> : ""}
      <Paper
        elevation={0}
        sx={{
          width: "100%",
          borderRadius: 4,
          overflow: "hidden",
          boxShadow: "0 8px 30px rgba(0,0,0,0.08)",
        }}
      >
        {/* Header */}
        <Box
          sx={{
            background: "linear-gradient(135deg,#1976d2 0%,#1565c0 100%)",
            color: "white",
            textAlign: "center",
            py: 5,
            px: 3,
          }}
        >
          <ScienceIcon sx={{ fontSize: 50, mb: 1 }} />

          <Typography variant="h4" fontWeight="bold">
            Laboratory Job Tracking
          </Typography>

          <Typography sx={{ mt: 1, opacity: 0.9 }}>
            Enter your Job Number to check the current progress
          </Typography>
        </Box>

        {/* Search Area */}
        <Box sx={{ p: 4 }}>
          <Box
            sx={{
              display: "flex",
              gap: 2,
              flexWrap: "wrap",
              alignItems: "center",
            }}
          >
            <FormControl
              sx={{
                minWidth: 130,
              }}
            >
              <InputLabel>Year</InputLabel>

              <Select
                value={year}
                label="Year"
                onChange={(e) => setYear(e.target.value)}
              >
                <MenuItem value="2025">2025</MenuItem>
                <MenuItem value="2026">2026</MenuItem>
                <MenuItem value="2027">2027</MenuItem>
              </Select>
            </FormControl>

            <TextField
              label="Job Number"
              placeholder="Enter job no"
              value={jobNo}
              onChange={(e) => setJobNo(e.target.value)}
              onKeyDown={handleKeyDown}
              sx={{
                flex: 1,
                minWidth: 250,
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon color="action" />
                  </InputAdornment>
                ),
              }}
            />

            <Button
              variant="contained"
              size="large"
              onClick={searchJob}
              disabled={loading}
              sx={{
                minWidth: 140,
                borderRadius: 2,
                textTransform: "none",
                fontSize: "16px",
                fontWeight: 600,
              }}
            >
              {loading ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                "Track Job"
              )}
            </Button>
          </Box>

          {/* Results */}
          {labRequestData && (
            <Paper
              elevation={0}
              sx={{
                mt: 4,
                p: 3,
                borderRadius: 3,
                border: "1px solid #e0e0e0",
                backgroundColor: "#fafafa",
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  mb: 3,
                  fontWeight: 600,
                  color: "#1976d2",
                }}
              >
                Job Progress
              </Typography>

              <LabRequestProgress labRequestData={labRequestData} />
            </Paper>
          )}
        </Box>
      </Paper>
    </Box>
  );
}

export default TrackJob;
